import graphql__623b6880189d9f02c295 from "./__generated__/AnonymousContributionFormBanner_anonymousMode.graphql.js";import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import AnonymousContributionSwitch from "./AnonymousContributionSwitch";
import { isAuthorized } from "../../Utils/authorizations";
import { useFormatMessage } from "../../Intl/Context";
import { useResponsiveFlag } from "../../Utils/ResponsiveQueries";

const AnonymousContributionFormBanner = props => {
  const { anonymous, onChange } = props;

  const anonymousMode = useFragment(
    AnonymousContributionFormBanner_anonymousMode,
    props.anonymousMode
  );

  const allowSignedInAnonymousContributions = isAuthorized(
    anonymousMode.authorizations.toggleAnonymousMode
  );
  const { forceAnonymousContributions } = anonymousMode;

  const viewer = useSelector(({ viewer }) => viewer);

  const t = useFormatMessage();
  const anonymousContributionBanner = t(intlMessages.anonymousContributionBanner);
  const nonAnonymousContributionBanner = t(intlMessages.nonAnonymousContributionBanner, {
    name: viewer?.name
  });
  const forcedAnonymousContributionBanner = t(
    intlMessages.forcedAnonymousContributionBanner
  );

  const { isDesktop } = useResponsiveFlag();

  if (!forceAnonymousContributions && !allowSignedInAnonymousContributions) return null;

  // When the module forces anonymous contributions, the banner always displays as
  // anonymous, no matter the current toggle value provided by the parent form.
  const displayAsAnonymous = forceAnonymousContributions || anonymous;

  const className = classNames(
    "box",
    "padding-x-lg",
    "padding-y-md",
    "margin-bottom-xs",
    {
      "bg-light": !displayAsAnonymous,
      "bg-secondary": displayAsAnonymous,
      "text-white": displayAsAnonymous,
      "d-flex": isDesktop,
      "align-items-center": isDesktop,
      "justify-content-between": isDesktop
    }
  );

  const labelClassName = classNames({
    "margin-bottom-none": isDesktop,
    "margin-bottom-sm": !isDesktop
  });

  let bannerLabel;

  if (forceAnonymousContributions) {
    bannerLabel = forcedAnonymousContributionBanner;
  } else if (anonymous) {
    bannerLabel = anonymousContributionBanner;
  } else {
    bannerLabel = nonAnonymousContributionBanner;
  }

  return (
    <div className={className} data-contribution-author-mode-banner>
      <p className={labelClassName}>{bannerLabel}</p>

      {!forceAnonymousContributions && (
        <AnonymousContributionSwitch
          anonymous={anonymous}
          handleAnonymousChange={onChange}
        />
      )}
    </div>
  );
};

const AnonymousContributionFormBanner_anonymousMode = graphql__623b6880189d9f02c295;

export default AnonymousContributionFormBanner;

const intlMessages = defineMessages({
  anonymousContributionBanner: {
    id: "contribution.form.anonymousContributionBanner",
    defaultMessage: "Vous contribuez anonymement."
  },
  nonAnonymousContributionBanner: {
    id: "contribution.form.nonAnonymousContributionBanner",
    defaultMessage: "Vous contribuez en tant que {name}."
  },
  forcedAnonymousContributionBanner: {
    id: "contribution.form.forcedAnonymousContributionBanner",
    defaultMessage:
      "Vous contribuez anonymement : ce module est configuré pour que toutes les " +
      "contributions soient anonymes."
  }
});
